import Api from '../Api';

import { url } from './config';
import { Company } from './types';

const api = new Api<Company>(url);

export default api;
